@if (isWarning) {
  <div class="align-center orange">
    <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
  </div>
}
<h1 mat-dialog-title [class.align-center]="isWarning" [class.orange]="isWarning" [class.no-padding]="isWarning">
  {{ data.title }}
</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog" (click)="cancel()">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content [class.align-center]="isWarning" [class.orange]="isWarning">
  <p>{{ data.body }}</p>
</div>
<div mat-dialog-actions class="row-reverse" [class.align-center]="isWarning">
  <button mat-raised-button color="primary" (click)="create()" cdkFocusInitial>Ja</button>
  <button mat-raised-button (click)="cancel()">Nej</button>
</div>
